import { useState, useEffect, useCallback } from 'react';

/**
 * Спільний стан шапки «Довідник умов» (/financial/sale-terms) — РЕДИЗАЙН.
 *
 * Фільтри (об'єкт · статус) винесено в топбар за §6 дизайн-контракту. Список
 * об'єктів кладе сюди ТІЛО сторінки після завантаження — топбар лише малює
 * опції, сам нічого не фетчить (той самий прийом, що setRange у
 * useMarketPricesUi).
 *
 * Синхронізація — модульний state + CustomEvent у межах вкладки.
 */
const EV = 'helios:sale-terms-ui-change';

export interface SaleTermsAssetOpt { id: string; assetName: string }

const state = {
  asset: '' as string,
  status: '' as string,
  assets: [] as SaleTermsAssetOpt[],
};

const emit = () => window.dispatchEvent(new CustomEvent(EV));

export function useSaleTermsUi() {
  const [, force] = useState(0);
  useEffect(() => {
    const refresh = () => force((x) => x + 1);
    window.addEventListener(EV, refresh);
    return () => window.removeEventListener(EV, refresh);
  }, []);

  const setAsset = useCallback((v: string) => { if (state.asset !== v) { state.asset = v; emit(); } }, []);
  const setStatus = useCallback((v: string) => { if (state.status !== v) { state.status = v; emit(); } }, []);
  const setAssets = useCallback((list: SaleTermsAssetOpt[]) => {
    const same = list.length === state.assets.length && list.every((a, i) => a.id === state.assets[i]?.id);
    if (!same) { state.assets = list; emit(); }
  }, []);

  return { asset: state.asset, status: state.status, assets: state.assets, setAsset, setStatus, setAssets };
}
